'use strict';exports.__esModule = true;exports.resetSliderState = exports.setSliderState = exports.loadProperties = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var loadProperties = (0, _reduxAct.createAction)('/LOAD_PROPERTIES');
var loadPropertiesSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_SUCCESS');
var loadPropertiesFail = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_FAIL');
var setSliderState = (0, _reduxAct.createAction)('/SET_SLIDER_CONFIG');
var resetSliderState = (0, _reduxAct.createAction)('/RESET_SLIDER_CONFIG');

var initialState = {
  loaded: false,
  loading: false };


var fetchLoad = function fetchLoad(_ref) {var _ref$requestType = _ref.requestType,requestType = _ref$requestType === undefined ? 'properties' : _ref$requestType,_ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params,carouselType = _ref.carouselType;return _axios2.default.get('/' + requestType + '/search', {
    params: params }).

  then(function (action) {return loadPropertiesSuccess({ action: action, carouselType: carouselType });}, loadPropertiesFail);};

var handleLoad = function handleLoad(state, action) {var _Object$assign;return (0, _reduxLoop.loop)(Object.assign({},
  state, (_Object$assign = {
    loading: true }, _Object$assign[
  action.carouselType + 'Skip'] = (0, _get2.default)(action, 'params.$skip', 0), _Object$assign)),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref2) {var _Object$assign2;var action = _ref2.action,carouselType = _ref2.carouselType;
  var data = (0, _get2.default)(action, 'data.data');
  var hasNextPage = (0, _get2.default)(action, 'data.meta.hasNextPage', false);
  return Object.assign({},
  state, (_Object$assign2 = {
    loading: false,
    loaded: true }, _Object$assign2[
  carouselType] = state[carouselType + 'Skip'] ? [].concat(state[carouselType], data) : data, _Object$assign2[
  carouselType + 'Meta'] = { hasNextPage: hasNextPage }, _Object$assign2[
  carouselType + 'SliderState'] = {
    index: 0,
    city: undefined,
    type: undefined }, _Object$assign2));


};

var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading home page properties');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleSetSliderState = function handleSetSliderState(state, _ref3) {var _Object$assign3;var carouselType = _ref3.carouselType,index = _ref3.index,city = _ref3.city,type = _ref3.type;return Object.assign({},
  state, (_Object$assign3 = {}, _Object$assign3[
  carouselType + 'SliderState'] = Object.assign({},
  state[carouselType + 'SliderState'], {
    index: index,
    city: city,
    type: type }), _Object$assign3));};



var handleResetSliderState = function handleResetSliderState(state, _ref4) {var _Object$assign4;var carouselType = _ref4.carouselType;return Object.assign({},
  state, (_Object$assign4 = {}, _Object$assign4[
  carouselType + 'SliderState'] = Object.assign({},
  initialState[carouselType + 'SliderState']), _Object$assign4));};



var foreignPropertyPageProperties = (0, _reduxAct.createReducer)(function (on) {
  on(loadProperties, handleLoad);
  on(loadPropertiesSuccess, handleLoadSuccess);
  on(loadPropertiesFail, handleLoadFail);
  on(setSliderState, handleSetSliderState);
  on(resetSliderState, handleResetSliderState);
}, initialState);exports.


loadProperties = loadProperties;exports.
setSliderState = setSliderState;exports.
resetSliderState = resetSliderState;exports.default =


foreignPropertyPageProperties;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/foreignPropertyPageProperties.js
// module id = 1258
// module chunks = 0